/**
 * The `/ajax/*` backend doesn't always send `errorMessage` as a string —
 * `loadTopic`/`loadTopicNoteList`'s auth rejection sends
 * `{"topicID":"Topic Not Authorized"}` instead of a plain string. Passing
 * that straight into `new Error()` stringifies it to `"[object Object]"`.
 * This pulls a readable string out of either shape.
 */
export function parseAjaxErrorMessage(errorMessage: unknown, fallback: string): string {
  if (typeof errorMessage === 'string' && errorMessage) return errorMessage
  if (errorMessage && typeof errorMessage === 'object') {
    const first = Object.values(errorMessage as Record<string, unknown>)[0]
    if (typeof first === 'string' && first) return first
  }
  return fallback
}

/** True for the backend's `isAllowed()` rejection — a real "you can't see this" response, not a network/server failure. */
export function isTopicNotAuthorized(errorMessage: unknown): boolean {
  return parseAjaxErrorMessage(errorMessage, '').toLowerCase().includes('not authorized')
}
